var map = {
	"./course-1.png": 953,
	"./course-2.png": 970,
	"./course-3.png": 731,
	"./course-4.png": 124,
	"./course-5.png": 637,
	"./course-6.png": 214,
	"./hero-image.png": 588,
	"./prefooter-collage.png": 988,
	"./validemy-logo-white.png": 169,
	"./validemy-logo.png": 581,
	"./werwe.png": 32,
	"./white_icon.png": 585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;